/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
"use strict";
// no deserialization is necessary in TS.
// This is only here to match dart interface
function deserializeGenericEvent(serializedEvent) {
    return serializedEvent;
}
exports.deserializeGenericEvent = deserializeGenericEvent;
//# sourceMappingURL=event_deserializer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/platform-browser/src/web_workers/worker/event_deserializer.js
// module id = 305
// module chunks = 2